import { Link } from "react-router-dom";

import ArrowLeft from "../../components/LogoSVG/ArrowLeft";
import ProjectRowChild from "./components/ProjectRowChild";

import { projects } from "./Data";

const contributions = [
  "Backend and Data Indexing services",
  "Search functionalities",
  "Video Work Flow",
  "Contentful App Webhook",
  ". . .",
];

const urls = [
  { name: "FIFA.com", url: "https://www.fifa.com/en" },
  { name: "Inside.FIFA.com", url: "https://inside.fifa.com/" },
  { name: "Media.FIFA.com", url: "https://media.fifa.com/" },
];

const FullProjectsPageDesktop = () => {
  return (
    <div className="mx-[80px] pt-16">
      <Link to={"/#projects"} className="flex items-center cursor-pointer">
        <ArrowLeft className="w-6 h-6" />
        <p className="ml-2 mt-1 font-normal text-gray-5 text-center hover:text-custom-white">
          Back
        </p>
      </Link>

      <div className="mt-8 text-[40px] font-bold">All Projects</div>

      <table className="mt-8 w-full border-collapse text-left">
        <thead className="sticky top-0 z-10 border-b border-slate-300/20 bg-gray-1 px-6 py-5 backdrop-blur">
          <tr>
            <th className="py-4 pr-8 font-medium">Project</th>
            <th className="py-4 pr-8 font-medium w-[400px] 2xl:w-[180px]">
              Made at
            </th>
            <th className="hidden py-4 w-[400px] 2xl:w-[450px] lg:table-cell font-medium">
              Built with
            </th>
            <th className="py-4 pr-8 font-medium">My Contributions</th>
            <th className="py-4 pr-8 font-medium">Link</th>
          </tr>
        </thead>

        <tbody className="text-[14px]">
          {projects.map((project) => (
            <ProjectRowChild
              nameProjects={project.name}
              madeAt={project.madeAt}
              techs={project.techs}
              contributions={project.contributions}
              urls={project.urls}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FullProjectsPageDesktop;
